import { __delete, __get, __post, __put } from "./xhr";
export var AbstractDomainData = {
  one: function one(domain, id, cb) {
    var response = {
      data: null,
      error: []
    };
    new Promise(function (accept, reject) {
      try {
        // console.log(`finding single data for `, domain, ` with id `, id)
        __get("/".concat(domain, "/").concat(id), {}, function (res) {
          var _res$http;
          // console.log(`the response is `, res)
          if ((res === null || res === void 0 || (_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200 && res.data) {
            accept(res.data);
          } else {
            reject(res.error);
          }
        });
      } catch (e) {
        reject(e);
      }
    }).then(function (data) {
      response.data = data;
      cb === null || cb === void 0 || cb(response);
    })["catch"](function (error) {
      response.error = error;
      cb === null || cb === void 0 || cb(response);
    });
  },
  put: function put(path, obj, cb) {
    var response = {
      data: null,
      error: [],
      success: []
    };
    new Promise(function (resolve, reject) {
      __put("/".concat(path), {
        body: JSON.stringify(obj)
      }, function (res) {
        var _res$http2;
        if ((res === null || res === void 0 || (_res$http2 = res.http) === null || _res$http2 === void 0 ? void 0 : _res$http2.code) === 200) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    }).then(function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    })["catch"](function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    });
  },
  post: function post(path, obj, cb) {
    var response = {
      data: null,
      error: [],
      success: []
    };
    new Promise(function (resolve, reject) {
      __post("/".concat(path), {
        body: JSON.stringify(obj)
      }, function (res) {
        var _res$http3;
        if ((res === null || res === void 0 || (_res$http3 = res.http) === null || _res$http3 === void 0 ? void 0 : _res$http3.code) === 200) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    }).then(function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    })["catch"](function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    });
  },
  del: function del(path, id, cb) {
    var response = {
      data: null,
      error: [],
      success: []
    };
    new Promise(function (resolve, reject) {
      __delete("/".concat(path, "/").concat(id), {}, function (res) {
        var _res$http4;
        if ((res === null || res === void 0 || (_res$http4 = res.http) === null || _res$http4 === void 0 ? void 0 : _res$http4.code) === 200) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    }).then(function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    })["catch"](function (xhr_response) {
      cb === null || cb === void 0 || cb(xhr_response);
    });
  }
};